module.exports = __webpack_public_path__ + "images/category_lp/fishing_gear/banner_9a0a1d23b3fed348c252c85dbdefbd83.png";